import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";
import { StyledButton, StyledH2, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
    generalConfigStore,
    setIsGift,
    setIsRewards,
    setIsStateChanged,
    setIsEnterOrScanPromoCode,
    setIsPagePromoCodeActive,
    setIsPaymentWithLoyaltyBalance,
} from "@store";
import { GODIA_LOYALTY } from "@constants/index";
import { store } from "@components/VerticalLayout/store";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useSelector } from "react-redux";

export function MainContent(): JSX.Element {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const { project } = useSnapshot(generalConfigStore);
    const { fideltyType, shopID, oneShop } = useSnapshot(store);

    const [isRewardsModalOpened, setIsRewardsModalOpened] = React.useState(
        false
    );
    const [pendingToggleState, setPendingToggleState] = React.useState<
        boolean | null
    >(null);

    const isEnterOrScanPromoCode = ((((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).promoCode as RewardType).active;

    const isGifts = ((((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).gifts as RewardType).active;
    const isRewards = ((((project.template.pages.subSteps[
        "customerBenefit"
    ] as unknown) as CustomerBenefitPageType)
        .options as CustomerBenefitOptionsType).rewards as RewardType).active;
    const shop_id = oneShop
        ? shopID
        : project.shopId !== undefined
        ? project.shopId
        : shopID;

    function activeLoyaltyBenefitsSwitchOnClickEvent(
        setState: Function,
        state: boolean,
        name: string
    ) {
        setState(!state);

        if (
            fideltyType[`${shop_id}`] === GODIA_LOYALTY &&
            name &&
            ["isRewards", "isPaymentWithLoyaltyBalance"].includes(name)
        ) {
            if (name === "isRewards") {
                setIsRewards(!state);
                if ([!state, isEnterOrScanPromoCode, isGifts].includes(true)) {
                    setIsPagePromoCodeActive(true);
                } else {
                    setIsPagePromoCodeActive(false);
                }
                setIsPaymentWithLoyaltyBalance(state);
            } else if (name === "isPaymentWithLoyaltyBalance") {
                setIsPaymentWithLoyaltyBalance(!state);
                setIsRewards(state);
            }

            setIsStateChanged(true);
        }
    }

    return (
        <React.Fragment>
            <StyledModal
                toggle={() => setIsRewardsModalOpened(false)}
                isOpen={isRewardsModalOpened}
                centered
            >
                <ModalHeader
                    className="text-capitalize"
                    toggle={() => setIsRewardsModalOpened(false)}
                >
                    <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
                </ModalHeader>

                <ModalBody>
                    {isRewards
                        ? t(
                              "Warning! Disabling the reward will activate loyalty payment and all related options. Do you want to continue?"
                          )
                        : t(
                              "Warning! Activating the reward will disable loyalty payment and all related options. Do you want to continue?"
                          )}
                </ModalBody>

                <ModalFooter className="border-top-0">
                    <CustomSecondaryColorButton
                        onClick={() => setIsRewardsModalOpened(false)}
                        rounded={true}
                        variant="primary"
                        outline
                    >
                        {t("Back")}
                    </CustomSecondaryColorButton>

                    <StyledButton
                        onClick={() => {
                            if (pendingToggleState !== null) {
                                activeLoyaltyBenefitsSwitchOnClickEvent(
                                    setIsRewards,
                                    !pendingToggleState,
                                    "isRewards"
                                );
                            }
                            setIsRewardsModalOpened(false);
                            setPendingToggleState(null);
                        }}
                        rounded={true}
                        variant={mainColor}
                    >
                        {t("Validate")}
                    </StyledButton>
                </ModalFooter>
            </StyledModal>

            <div
                className="mx-2 m-2 rounded border"
                style={{ borderColor: "#CECECE" }}
            >
                <div
                    className="text-left px-4 d-flex align-items-center cursor__clz"
                    style={{
                        backgroundColor: "#EDEDED",
                        height: "40px",
                        fontSize: "20px",
                    }}
                >
                    {t("Loyalty benefit")}
                </div>
                <div className="p-4">
                    <div className="d-flex flex-row justify-content-between align-items-center">
                        {t("Scan or enter a promo code")}

                        <ReactSwitch
                            className="ksk_chk_expertTicketDematerialize"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={isEnterOrScanPromoCode}
                            onChange={() => {
                                setIsEnterOrScanPromoCode(
                                    !isEnterOrScanPromoCode
                                );
                                if (
                                    [
                                        isRewards,
                                        !isEnterOrScanPromoCode,
                                        isGifts,
                                    ].includes(true)
                                ) {
                                    setIsPagePromoCodeActive(true);
                                } else {
                                    setIsPagePromoCodeActive(false);
                                }
                            }}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                        />
                    </div>

                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>{t("Gifts")}</div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={isGifts}
                            onChange={() => {
                                setIsGift(!isGifts);
                                if (
                                    [
                                        isRewards,
                                        isEnterOrScanPromoCode,
                                        !isGifts,
                                    ].includes(true)
                                ) {
                                    setIsPagePromoCodeActive(true);
                                } else {
                                    setIsPagePromoCodeActive(false);
                                }
                            }}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                        />
                    </div>
                    <div className="py-2 d-flex flex-rows justify-content-between align-items-center">
                        <div>{t("Reward / point store")}</div>
                        <ReactSwitch
                            uncheckedIcon={false}
                            checkedIcon={false}
                            handleDiameter={26}
                            offColor="#f7b4b8"
                            offHandleColor="#E30613"
                            checked={isRewards}
                            onChange={() => {
                                setPendingToggleState(!isRewards);
                                setIsRewardsModalOpened(true);
                            }}
                            onColor="#c2eddd"
                            onHandleColor="#34C38F"
                            width={50}
                            height={20}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
